import { Link } from "react-router-dom";
import { membershipPlans, planById, planPath, type PlanId } from "@/lib/plans";
export function PlanSignupChoice({
  value,
  onChange,
  onContinue,
  onCompare,
}: {
  value: PlanId;
  onChange: (value: PlanId) => void;
  onContinue: () => void;
  onCompare: () => void;
}) {
  const selected = planById(value);
  return (
    <section className="space-y-4">
      <p className="text-sm text-white/75">
        Step 1 of 2 · Choose your starting plan
      </p>
      <fieldset className="grid grid-cols-2 gap-3">
        <legend className="mb-3 text-lg font-bold">
          How will you use PokeLlama?
        </legend>
        {membershipPlans.map((plan) => (
          <label
            key={plan.id}
            className={
              "min-w-0 cursor-pointer rounded-xl border p-3 text-sm " +
              (value === plan.id
                ? "border-cyan-300 bg-cyan-300/10"
                : "border-white/20")
            }
          >
            <span className="flex items-start gap-2">
              <input
                type="radio"
                name="signup-plan"
                value={plan.id}
                className="mt-1 shrink-0"
                checked={value === plan.id}
                onChange={() => onChange(plan.id)}
              />
              <strong>{plan.name}</strong>
            </span>
            <span className="mt-2 block text-xs sm:text-sm">
              {plan.price} <span className="text-white/70">{plan.cadence}</span>
            </span>
          </label>
        ))}
      </fieldset>
      <div
        aria-live="polite"
        className="rounded-xl bg-white/5 p-3 text-xs text-white/80"
      >
        <p className="font-semibold text-white">{selected.audience}</p>
        <p className="mt-1">{selected.features.slice(0, 2).join(" · ")}</p>
      </div>
      <p className="text-sm text-white/80">
        {selected.available
          ? value === "free"
            ? "Start free. No payment card is required."
            : "Create your account first, then review monthly or annual billing. Choosing a plan does not charge you."
          : "This subscription is coming soon. Create a Free account now; your plan preference will be carried into the plan review."}
      </p>
      <button
        type="button"
        className="min-h-11 w-full rounded-xl bg-cyan-300 px-4 font-bold text-slate-950"
        onClick={onContinue}
      >
        {selected.available
          ? "Continue with " + selected.name
          : "Continue free · review " + selected.name}
      </button>
      <Link
        to={planPath(value)}
        onClick={onCompare}
        className="inline-flex min-h-11 items-center text-sm text-cyan-200 underline"
      >
        Compare all benefits
      </Link>
    </section>
  );
}
